import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { I18n } from 'react-i18next'
import { withI18next } from 'gatsby-plugin-i18next'
import {Helmet} from "react-helmet"
import BackgroundImage from 'gatsby-background-image'

// Lets import favIcons
import appleIcon from '../img/favicons/apple-touch-icon.png'
import fav32 from '../img/favicons/favicon-32x32.png'
import fav16 from '../img/favicons/favicon-16x16.png'
import safariPinnedTab from '../img/favicons/safari-pinned-tab.svg'
import faviconIco from '../img/favicons/favicon.ico'
import logo from '../img/logo.png'

// Lets import utils functions
import { utils } from '../utils/index'

import Layout from '../components/Layout'

// Lets import styles for component
import './index-page.sass'

// Lets import components
import CountryChooser from '../components/CountryChooser/CountryChooser'
import VideosWrap from '../components/VideosWrap/VideosWrap'
import VideoModal from '../components/VideoModal/VideoModal'

export const IndexPageTemplate = (
  {
    title,
    image,
    countries,
    categories,
    videos,
    videoBlocks,
    activeCountry,
    activeVideo,
    languages,
    t,
    l,
  }) => {
  return (
    <div>
      <section className="banner">
        <h3 className="title">{title}</h3>
        {Object.hasOwnProperty.call(image, 'src') ? <BackgroundImage tag="section" fluid={image} className="bannerBackground" /> : <img src={image} alt="banner iamge" />}
      </section>
      <div className="countryChooser">
        {countries ? (
          <CountryChooser countries={countries} activeCountry={activeCountry} t={t} l={l} />
        ) : null}
      </div>
      <div className="videosWrap">
        {videos && videoBlocks && categories ? (
          <VideosWrap videos={videos} videoBlocks={videoBlocks} categories={categories} activeCountry={activeCountry} t={t} l={l} />
        ) : null}
      </div>
      <div>
      {activeVideo ? (
        <VideoModal video={activeVideo} languages={languages} t={t} l={l} />
      ) : null}
      </div>
    </div>
  )
}
class IndexPage extends Component {
  render() {
    const { pageContext, data } = this.props
    const { allMarkdownRemark } = data
    const indexPage = utils.getEntityByKey(allMarkdownRemark.edges, 'templateKey')
    const socialNetworks = utils.getEntityByType(allMarkdownRemark.edges, 'networks')
    const countries = utils.getEntityByType(allMarkdownRemark.edges, 'countries')
    const categories = utils.getEntityByType(allMarkdownRemark.edges, 'categories')
    const languages = utils.getEntityByType(allMarkdownRemark.edges, 'languages')
    const videos = utils.getEntityByType(allMarkdownRemark.edges, 'videos')
    const videoBlocks = utils.getEntityByType(allMarkdownRemark.edges, 'videoBlocks')
    const indexSocialNetworks = utils.getIndexPageEntities(indexPage.networks, socialNetworks, 'title')
    const indexCountries = utils.orderByName(utils.getIndexPageEntities(indexPage.countries, countries, 'title'))
    const indexCategories = utils.getIndexPageEntities(indexPage.categories, categories, 'title')
    const activeCountry = Object.hasOwnProperty.call(pageContext, 'country') ? pageContext.country : ''
    const activeVideo = Object.hasOwnProperty.call(pageContext, 'slug')
        ? utils.getActiveVideo(allMarkdownRemark.edges, videoBlocks, {slug: pageContext.slug})
        : ''
    const activeVideoTitle = activeVideo ? activeVideo.activeVideo.title : ''
    const activeVideoSlug = activeVideo ? activeVideo.activeVideo.slug : ''
    const activeVideoDescription = activeVideo ? activeVideo.activeVideo.description : ''
      const activeVideoImage = activeVideo && activeVideo.activeVideo && activeVideo.activeVideo.thumbnail ? 'https://eu4energy.eu/videos' + activeVideo.activeVideo.thumbnail.publicURL : ''
    return (
      <I18n>
        {(t, l) => (
          <Layout socialNetworks={indexSocialNetworks} t={t}>
            <Helmet>
              <link rel="apple-touch-icon" sizes="180x180" href={appleIcon} />
              <link rel="icon" type="image/png" sizes="32x32" href={fav32} />
              <link rel="icon" type="image/png" sizes="16x16" href={fav16} />
              <link rel="mask-icon" href={safariPinnedTab} color="#5bbad5" />
              <link rel="shortcut icon" href={faviconIco} />
              <meta name="msapplication-TileColor" content="#da532c" />
              <meta name="msapplication-config" content="../img/favicons/browserconfig.xml" />
              <meta name="theme-color" content="#ffffff" />

              <title>{activeCountry || activeVideoTitle || t('home_title')} | EU NEIGHBOURS</title>
              <meta name="title" content={activeCountry ? `${activeCountry} | EU NEIGHBOURS` : activeVideoTitle ? `${activeVideoTitle} | EU NEIGHBOURS` : `${t('home_title')} | EU NEIGHBOURS`} />
              <meta name="description" content={activeVideoDescription || t('home_meta_description')} />

              <meta property="og:type" content="website" />
              <meta property="og:url" content={activeVideoSlug ? `https://eu4energy.eu/videos/${l.i18n.language}${activeVideoSlug}` : `https://eu4energy.eu/videos/${l.i18n.language}/${activeCountry ? 'countries/'+activeCountry.toLowerCase() : ''}`} />
              <meta property="og:title" content={activeCountry ? `${activeCountry} | EU NEIGHBOURS` : activeVideoTitle ? `${activeVideoTitle} | EU NEIGHBOURS` : `${t('home_title')} | EU NEIGHBOURS`} />
              <meta property="og:description" content={activeVideoDescription || t('home_meta_description')} />
              <meta property="og:image:height" content="364" />
              <meta property="og:image:width" content="696" />
              <meta property="og:image" content={activeVideoImage ? activeVideoImage : `https://eu4energy.eu${logo}`} />

              <meta property="twitter:card" content="summary_large_image" />
              <meta property="twitter:url" content={activeVideoSlug ? `https://eu4energy.eu/videos/${l.i18n.language}${activeVideoSlug}` : `https://eu4energy.eu/videos/${l.i18n.language}/${activeCountry ? 'countries/'+activeCountry.toLowerCase() : ''}`} />
              <meta property="twitter:title" content={activeCountry ? `${activeCountry} | EU NEIGHBOURS` : activeVideoTitle ? `${activeVideoTitle} | EU NEIGHBOURS` : `${t('home_title')} | EU NEIGHBOURS`} />
              <meta property="twitter:description" content={activeVideoDescription || t('home_meta_description')} />
              <meta property="twitter:image:height" content="364" />
              <meta property="twitter:image:width" content="696" />
              <meta property="twitter:image" content={activeVideoImage ? activeVideoImage : `https://eu4energy.eu${logo}`} />
            </Helmet>
            <IndexPageTemplate
              title={indexPage.title}
              image={indexPage.image.childImageSharp.fluid}
              countries={indexCountries}
              activeCountry={activeCountry}
              videos={videos}
              categories={indexCategories}
              videoBlocks={videoBlocks}
              activeVideo={activeVideo}
              languages={languages}
              t={t}
              l={l}
            />
          </Layout>
        )}
      </I18n>
    )
  }
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default withI18next()(IndexPage)

export const pageQuery = graphql`
  query IndexPageTemplate($lng: String!) {
    locales: allLocale(filter: { lng: { eq: $lng }, ns: { eq: "messages" } }) {
      ...TranslationFragment
    }
    allMarkdownRemark {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            template
            templateKey
            image {
              childImageSharp {
                fluid(maxWidth: 2000, quality: 80) {
                  ...GatsbyImageSharpFluid_withWebp
                }
                fixed(width: 250) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
              publicURL
            }
            title
            titleRu
            color
            url
            icon {
              publicURL
            }
            networks {
              network
            }
            countries {
              country
            }
            categories {
              category
            }
            langShort
            country
            category
            date
            downloads {
              title
              url
            }
            lang
            thumbnail {
              childImageSharp {
                fixed(width: 250) {
                  ...GatsbyImageSharpFixed_withWebp
                }
                fluid(maxWidth: 1000, quality: 60) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
              publicURL
            }
            url
            description
            videos {
              video
            }
          }
        }
      }
    }
  }
`
